import { render, staticRenderFns } from "./GoogleFilePicker.vue?vue&type=template&id=012f4427"
import script from "./GoogleFilePicker.vue?vue&type=script&lang=js"
export * from "./GoogleFilePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('012f4427')) {
      api.createRecord('012f4427', component.options)
    } else {
      api.reload('012f4427', component.options)
    }
    module.hot.accept("./GoogleFilePicker.vue?vue&type=template&id=012f4427", function () {
      api.rerender('012f4427', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/google-file-picker/GoogleFilePicker.vue"
export default component.exports